import { useNavigate } from 'react-router-dom';

/**
 * `/billing/cancel` — Stripe redirects here when the user backs out of Checkout.
 * Offer a retry back into the signup flow.
 *
 * Functional scaffolding — unstyled.
 */
export function CheckoutCancel() {
  const navigate = useNavigate();
  return (
    <div>
      <p>Checkout canceled.</p>
      <button type="button" onClick={() => navigate('/signup')}>
        Try again
      </button>
    </div>
  );
}
